<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-cancelar="cancelar"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Salvar"
			:is-confirmar-desabilitado="!formIsValid"
			@close="cancelar"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Tipo" obrigatorio-por-padrao class="mb-2">
						</label-personalizado>
						<v-autocomplete
							id="novo-modelo-tipos-documentos"
							v-model="tipoDocumentoModelo"
							:items="tiposDataSource"
							placeholder="Informe"
							class="pt-0"
							item-value="id"
							item-text="nome"
							dense
							clearable
							:rules="regrasTipoDocumentoModelo"
						>
						</v-autocomplete>
					</v-col>
					<v-col cols="12">
						<label-personalizado
							nome-campo="Titulo"
							obrigatorio-por-padrao
							class="mb-2"
						></label-personalizado>
						<v-text-field
							v-model="tituloDocumentoModelo"
							id="novo-modelo-titulo"
							placeholder="Informe"
							type="string"
							clearable
							counter="100"
							:rules="regrasTituloDocumentoModelo"
							class="ma-0 py-0"
						>
						</v-text-field>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import { actionTypes, mutationTypes } from '@/core/constants/index'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'novo-modelo-documento',
	components: { LabelPersonalizado },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		modeloDocumento: {
			type: Object,
			default: () => {
				return {
					id: null,
				}
			},
			required: false,
		},
	},
	data() {
		return {
			formIsValid: false,
			tiposDataSource: [],
			tipoDocumentoModelo: null,
			tituloDocumentoModelo: '',
			urlDocumentoModelo: '',
			regrasTituloDocumentoModelo: [
				(value) => this.regraObrigatoriedade(value, 'Campo obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						100,
						'O campo de título deve ser igual ou menor do que 100 caracteres!',
					),
			],
			regrasTipoDocumentoModelo: [(value) => this.regraObrigatoriedade(value, 'Seleção obrigatória.')],
		}
	},
	computed: {
		isEditar() {
			return this.modeloDocumento.id
		},
		titulo() {
			return this.isEditar ? 'Editar Modelo de Documentos' : 'Novo Modelo de Documentos'
		},
	},
	async mounted() {
		await this.carregarTiposModeloDocumento()
		await this.carregarDocumentoModeloExistente()
	},
	methods: {
		async carregarTiposModeloDocumento() {
			const { itens } = await this.$store.dispatch(
				actionTypes.CONFIGURACAO.TIPO_MODELO_DOCUMENTO.BUSCAR_TIPOS_MODELO_DOCUMENTOS_ATIVOS,
				{
					buscarTodosTipos: true,
				},
			)

			this.tiposDataSource = itens
		},
		async confirmar() {
			if (this.$refs.form.validate()) {
				await this.criarDocumentoModelo()

				this.mostrarNotificacaoSucessoDefault()
				this.recarregarListagemExterna()
				this.fecharModal()
			}
		},
		fecharModal() {
			this.$emit('redirecionar-editor-texto', [this.urlDocumentoModelo])
			this.cancelar()
		},
		cancelar() {
			this.limparDocumentoModelo()
			this.$emit('fechar-modal')
		},
		async criarDocumentoModelo() {
			if (!this.isEditar) {
				const documentoCriado = await this.$store.dispatch(
					actionTypes.CONFIGURACAO.MODELO_DOCUMENTO.CRIAR_MODELO_DOCUMENTO,
					this.getDocumentoModelo(),
				)

				this.urlDocumentoModelo = documentoCriado.urlEdicao
			}
		},
		limparDocumentoModelo() {
			this.tipoDocumentoModelo = null
			this.tituloDocumentoModelo = ''
		},
		async carregarDocumentoModeloExistente() {
			if (this.isEditar) {
				this.tipoDocumentoModelo = this.modeloDocumento.tipo
				this.tituloDocumentoModelo = this.modeloDocumento.titulo
			}
		},
		getDocumentoModelo() {
			let dados = {
				idTipoDocumento: this.tipoDocumentoModelo,
				nome: this.tituloDocumentoModelo,
			}

			if (this.isEditar) {
				dados.id = this.modeloDocumento.id
			}

			return dados
		},
		recarregarListagemExterna() {
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_FILTRO_LISTAGEM)
			this.$store.commit(mutationTypes.CONFIGURACAO.MODELO_DOCUMENTO.RESET_PAGINACAO_LISTAGEM)
			this.$emit('recarregar-listagem-modelo-documento')
		},
	},
}
</script>
